import React, { memo } from "react";
import * as PropTypes from "prop-types";
import PivotTable from "../../table/PivotTable";

const UsersBySectorTable = props => (
  <PivotTable
    reference="2.1"
    caption="Users by Sector, 2018"
    subcaption="Segmented by GNI Group"
    titles={[
      {
        key: "areas",
        title: "",
        columnSpan: 1
      },
      {
        key: "total",
        title: "",
        columnSpan: 1,
        total: true
      },
      {
        key: "sectors",
        title: "",
        columnSpan: 2,
        groupEnd: true
      },
      {
        key: "privateSector",
        title: "Within Private",
        columnSpan: 2
      }
    ]}
    columnKey="sector"
    columnDefinitions={[
      {
        value: "Total",
        label: "Total",
        total: true
      },
      {
        value: "Public"
      },
      {
        value: "Private",
        groupEnd: true
      },
      {
        value: "Private Sub",
        label: "Subsidized"
      },
      {
        value: "Private Non-Sub",
        label: "Non-Subsidized"
      }
    ]}
    rowKey="area"
    rowDefinitions={[
      {
        value: "Low-Income (LIC)",
        label: "LICs"
      },
      {
        value: "Lower-Middle-Income (L-MIC)",
        label: "L-MICs"
      },
      {
        value: "Upper-Middle-Income (U-MIC)",
        label: "U-MICs"
      },
      {
        value: "Total",
        label: "Total",
        total: true
      }
    ]}
    data={props.data}
  />
);

UsersBySectorTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(UsersBySectorTable);
